<template>
  <div>
    <div class="userList">
      <div
        v-for="(item, index) in list"
        :key="index"
        :class="index == value ? 'name active' : 'name'"
      >
        <p v-if="item.name == $chat.role.name" style="color: orange">{{ item.name }}</p>
        <p v-else @click="check(item.name, index)">{{ item.name }}</p>
        <p v-if="item.name == $chat.role.name" style="color: orange">管理员</p>

        <p v-else @click="check(item.name, index)">操作</p>
      </div>
    </div>
    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <div class="check" v-if="flag">
        <el-checkbox
          label="是否禁止语音"
          v-model="type[0]"
          :true-label="1"
          :false-label="0"
        ></el-checkbox>
        <el-checkbox
          label="是否禁止视频"
          v-model="type[1]"
          :true-label="1"
          :false-label="0"
        ></el-checkbox>
        <el-checkbox
          label="是否禁止加入房间"
          v-model="type[2]"
          :true-label="1"
          :false-label="0"
        ></el-checkbox>
        <el-checkbox
          label="是否禁止屏幕共享"
          v-model="type[3]"
          :true-label="1"
          :false-label="0"
        ></el-checkbox>
        <el-checkbox
          label="是否给予主持人权限"
          v-model="type[4]"
          :true-label="1"
          :false-label="0"
        ></el-checkbox>

        <el-button type="primary" @click="save">确认</el-button>

        <el-button
          type="error"
          @click="
            flag = false;
            value = -1;
          "
          >取消</el-button
        >
      </div>
    </transition>
  </div>
</template>

<script>
import { check_status, change_status } from "../assets/api/index";
export default {
  data() {
    return {
      list: [],
      value: -1,
      type: [],
      flag: false,
      name: "",
    };
  },
  methods: {
    check(e, i) {
      console.log(e);
      this.value = i;
      this.flag = true;
      this.name = e;
      check_status({
        name: e,
      }).then((res) => {
        console.log(res);
        if (res.status == null) {
          this.type = [0, 0, 0, 0, 0];
        } else {
          this.type = JSON.parse(res.status);
        }
      });
    },
    save() {
      change_status({
        name: this.name,
        status: JSON.stringify(this.type),
      }).then((res) => {
        if (res.code == 0) {
          this.$message.info({
            type: "success",
            message: "修改权限成功",
          });
        }
        var message = `${this.type[0]}-${this.type[1]}-${this.type[2]}-${this.type[3]}-${this.type[4]}`;
        this.$chat.send(`manage,${this.name},${message}`);
      });
    },
  },
  created() {
    this.list = this.$chat.playerList;
    console.log(this.list);

    this.Bus.$on("playerList", (e) => {
      this.list = e;
    });
  },
};
</script>

<style lang="scss" scoped>
.userList {
  position: fixed;
  left: 0;
  width: 250px;
  height: 400px;
  background: rgba($color: #262626, $alpha: 0.8);

  top: 65px;
  padding-top: 20px;
  overflow-y: scroll;
  z-index: 9999;
  .name {
    height: 30px;
    justify-content: space-between;
    color: #dfdfdf;
    display: flex;
    align-items: center;
    padding: 0 20px;
    font-size: 14px;
    p {
      cursor: pointer;
    }
  }
  .active {
    color: #1dd3b0;
  }
}

.check {
  position: fixed;
  left: 251px;
  width: 200px;
  height: 230px;
  top: 65px;
  background: rgba($color: #262626, $alpha: 0.8);
  padding-top: 20px;

  .el-checkbox {
    margin-left: 20px;
    width: 100%;
    text-align: left;
    color: #dfdfdf;
    font-size: 14px;
    margin-bottom: 10px;
  }
  .el-button {
    font-size: 12px;
    margin-top: 20px;
  }
}
.userList::-webkit-scrollbar {
  width: 4px;
  opacity: 0.6;
}

.userList::-webkit-scrollbar-track {
  background: #ffffff;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
}

.userList::-webkit-scrollbar-thumb {
  background-color: #1dd3b0;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
}
</style>
